import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{attrs:{"label":_vm.label,"error-messages":_vm.errors,"suffix":"CA$","readonly":_vm.readonly},on:{"input":_vm.doTouch,"blur":_vm.doTouch},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }